import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';

@Component({
  selector: 'tt-transport-area-pp',
  templateUrl: './transport-area-pp.component.html',
  styleUrls: ['./transport-area-pp.component.css']
})
export class TransportAreaPpComponent implements OnInit {
    transportAreaPpKeyno;

    public edit?: Edit;

    public selectListTransportAreas: Item[] = [];

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.transportAreaPpKeyno = this.stateService.getStateParams()['transportareapp_keyno'];
    }

    private async loadEdit() {
        if (!!this.transportAreaPpKeyno) {
            this.edit = (await this.datatask.Post(1405, { transportareapp_keyno: this.transportAreaPpKeyno }))[0];
        }
    }

    private async loadTransportAreas(): Promise<void> {
        if (!!this.edit?.stockplace_id) {
            return this.selectListTransportAreas = await this.datatask.Post(1397, { stockplace_id: this.edit.stockplace_id });
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(1406, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        await this.loadEdit();
        this.loadTransportAreas();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    transportareapp_keyno: number;
    postplace_id_and_name: string;
    stockplace_name: string;
    transportarea_keyno: number;
    stockplace_id: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('transportAreaPp', {
//        templateUrl: 'views/components/views/transportAreaPp/transportAreaPp.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'modalService', 'translateService', 'transportAreaPpService', function ($stateParams, stateService, utilityService, modalService, translateService, transportAreaPpService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let transportAreaPpKeyno = $stateParams.transportareapp_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                edit: {},
//                selectListTransportAreas: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            translateService.translateBatch(translations).then(function (data) {
//                angular.forEach(translations, function (_, key) {
//                    if (angular.isDefined(data[key])) {
//                        translations[key] = data[key];
//                    }
//                });
//            });

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE CALLS

//            async function loadEdit() {
//                vm.model.edit = (await transportAreaPpService.getPostPlace({ transportareapp_keyno: transportAreaPpKeyno }))[0];

//                return loadTransportAreas();
//            }

//            async function loadTransportAreas() {
//                if (utilityService.validateParmsValue(vm.model.edit.stockplace_id) !== true) return;

//                return vm.model.selectListTransportAreas = await transportAreaPpService.listTransportAreas({ stockplace_id: vm.model.edit.stockplace_id });
//            }

//            // #endregion LOAD PROCEDURE CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                transportAreaPpService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadEdit();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
